// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"oz_a bii_a bii_x","FilterForm__vgroup":"oz_b bii_sv"};